/** Контейнер уведомлений о новых сообщениях всех каналов */
export const CHAT_INCOMING_TOASTER_ID = 'chat-incoming';
